import { render, staticRenderFns } from "./P2POffers.vue?vue&type=template&id=56c9a78a&scoped=true&"
import script from "./P2POffers.vue?vue&type=script&lang=js&"
export * from "./P2POffers.vue?vue&type=script&lang=js&"
import style0 from "./P2POffers.vue?vue&type=style&index=0&id=56c9a78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9a78a",
  null
  
)

export default component.exports